import gql from 'graphql-tag';

const GET_LOCATIONS = gql`
  query locations($where: LocationListWhereInput) {
    locations(where: $where) {
      id
      tag
      isEnabled
      createdAt
      updatedAt
    }
  }
`;

const CREATE_STORAGE_REPORT = gql`
  mutation createStorageReport($data: CreateStorageReportInput!) {
    createStorageReport(data: $data) {
      id
      closedAt
      createdAt
      updatedAt
    }
  }
`;

export { GET_LOCATIONS, CREATE_STORAGE_REPORT };
